import React from 'react'
import { getImages } from '../../../const'
import { Link, useNavigate } from 'react-router-dom'

const TopActions = ({ handleTripStats }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className='mr-mid-header'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='arw-back'><a href="/"><img src={getImages('icon-arrow-back.png')} /></a></div>
                    <div className='d-flex align-items-center'>
                        {/* <div className='me-2'>
                            <button className='btn common-btn px-md-4 btn-blue-bg d-flex align-items-center' type='button'>
                                <span className='icon-chart font-20 text-white me-2'></span>
                                <div className='xss-title text-white'>Trip Stats</div>
                            </button>
                        </div>
                        <div className='me-2'>
                            <button className='btn common-btn px-md-4 btn-blue-bg d-flex align-items-center' type='button'>
                                <span className='icon-eye font-20 text-white me-2'></span>
                                <div className='xss-title text-white'>What to See</div>
                            </button>
                        </div> */}
                        <div>
                            <button className='btn common-btn px-md-4 d-flex align-items-center' type='button' onClick={handleTripStats}>
                                <span className='icon-share font-20 me-2'></span>
                                <div className='xss-title'>Share Trip</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TopActions